import config from "config/website";

const preloadConfig = {
  maxConcurrentPreload: 3,
  maxPreloadQueueLength: 30,
  ...(config && config.preload ? config.preload : {}),
};

export const abortErrorMessage =
  "Aborted because the promise queue was too long.";

export default (maxConcurrentPromises, maxQueueLength) => {
  maxConcurrentPromises =
    maxConcurrentPromises || preloadConfig.maxConcurrentPreload;
  maxQueueLength = maxQueueLength || preloadConfig.maxPreloadQueueLength;
  let queue = [];
  let ongoingPromises = 0;

  const getOngoingPromises = () => ongoingPromises;
  const setOngoingPromises = (newValue) => {
    ongoingPromises = newValue;
  };
  const getQueue = () => queue;
  const setQueue = (newQueue) => {
    queue = newQueue;
  };

  let hasIdleCallback = false;

  const consumeQueue = () => {
    if (hasIdleCallback) {
      return;
    }

    hasIdleCallback = true;
    requestIdleCallback(() => {
      hasIdleCallback = false;
      const queue = getQueue();
      if (queue.length === 0 || getOngoingPromises() >= maxConcurrentPromises) {
        return;
      }

      const numberOfPromisesToLaunch = Math.min(
        queue.length,
        maxConcurrentPromises
      );
      const promisesToLaunch = queue.slice(-numberOfPromisesToLaunch);
      const promisesToAborted = queue.slice(
        0,
        queue.length - maxQueueLength - numberOfPromisesToLaunch
      );
      const remainingQueue = queue.slice(
        -maxQueueLength - numberOfPromisesToLaunch,
        -numberOfPromisesToLaunch
      );

      setQueue(remainingQueue);

      promisesToAborted.forEach(({ abort }) => {
        abort(new Error(abortErrorMessage));
      });

      setOngoingPromises(getOngoingPromises() + numberOfPromisesToLaunch);
      promisesToLaunch.forEach(({ promiseFactory }) => {
        promiseFactory().then(() => {
          setOngoingPromises(getOngoingPromises() - 1);
          consumeQueue();
        });
      });
    });
  };

  return {
    add: (promiseFactory) => {
      return new Promise((resolve, reject) => {
        queue.push({
          promiseFactory: () => {
            return promiseFactory()
              .then((result) => {
                resolve(result);
              })
              .catch((error) => {
                reject(error);
              });
          },
          abort: reject,
        });
        consumeQueue();
      });
    },
  };
};
